// eslint-disable-next-line spaced-comment
export default ({ size, color = '#000' } = {}) => /*html*/`
<svg width="${ size }" height="${ size }" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.95035 2.54937L11.451 6.04997L3.84954 13.6514L0.728473 13.9959C0.310654 14.0421 -0.04236 13.6888 0.00412516 13.271L0.351397 10.1478L7.95035 2.54937ZM13.6161 2.02819L11.9724 0.384528C11.4597 -0.128176 10.6282 -0.128176 10.1155 0.384528L8.56915 1.93084L12.0698 5.43145L13.6161 3.88513C14.1288 3.37215 14.1288 2.54089 13.6161 2.02819Z" fill="${ color }"/>
</svg>
`
